/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RegisterCardCollateralRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {RegisterCardCollateralResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const registerCardCollateral = (request: RegisterCardCollateralRequest, options?: CashRequestOptions) => post<RegisterCardCollateralRequest, RegisterCardCollateralResponse>("/2.0/cash/register-card-collateral", request, {...options, rejectOnError: true })